var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bubble && _vm.bubble.text)?_c('div',{key:_vm.bubble.token,staticClass:"chat-bubble"},[_c('ChatRichText',{attrs:{"text":_vm.bubble.text,"compact":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }